/* ============
 * Edit Page
 * ============
 *
 * This is the page for editing a product group.
 */
import { mapGetters } from 'vuex';
import batchService from './../../../../services/batch';
import recipeService from './../../../../services/recipe';
import batchTransformer from './../../../../transformers/batch';
import Forms from './../../../../utils/forms/forms';
import store from './../../../../store';

export default {
  data() {
    return {
      form: new Forms({
        recipeId: {
          value: '',
          type: 'select',
        },
        batchNumber: {
          value: '',
          type: 'number',
        },
        status: {
          value: '',
          type: 'hidden',
        },
        startDate: {
          type: 'date',
          value: '',
        },
        endDate: {
          type: 'date',
          value: '',
        },
        bestBeforeDate: {
          type: 'date',
          value: '',
        },
        notes: {
          value: '',
          type: 'textarea',
        },
      }),
    };
  },

  created() {
    if (!this.form.status) {
      Object.keys(this.form.fields).forEach((field) => {
        this.form.hideField(field);
      });
    }
    Promise.all([
      recipeService.all(),
    ]).then(() => {
      this.loading = false;
    });
    this.show();
  },

  computed: {
    ...mapGetters({
      recipes: 'allRecipes',
    }),
  },

  methods: {
    handleStatusChange(status) {
      this.form.showField('name');
      this.form.showField('recipeId');
      this.form.showField('notes');
      switch (status) {
        case 'planned':
          this.form.showField('startDate');
          this.form.showField('endDate');
          this.form.hideField('batchNumber');
          this.form.hideField('bestBeforeDate');
          break;
        case 'started':
          this.form.showField('batchNumber');
          this.form.hideField('bestBeforeDate');
          this.form.hideField('startDate');
          this.form.hideField('endDate');
          break;
        default:
          this.form.showField('batchNumber');
          this.form.showField('startDate');
          this.form.showField('endDate');
          this.form.showField('bestBeforeDate');
          break;
      }
    },
    /**
     * Method to update the product group.
     */
    update() {
      this.form.loading = true;
      const batch = batchTransformer.send(this.form.data());
      batchService.update(store.state.route.params.id, batch)
      .then(() => {
        this.form.loading = false;
        this.$message({
          message: this.$t('static.batches.edit.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'production.batches.index',
        });
      }).catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /**
     * Fetches the product group object for editing.
     */
    show() {
      this.loading = true;
      batchService.show(store.state.route.params.id).then((batch) => {
        this.form.assignData(batch);
        this.handleStatusChange(batch.status);
        this.loading = false;
      });
    },
    camalize(str) {
      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    },
  },

  watch: {
    recipes(recipes) {
      this.form.setOptions('recipeId', recipes.map(c => ({
        id: c.id,
        name: c.name,
      })));
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/batches/edit/edit.js